import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "attachments-selector" */ './AttachmentsSelectorCtnr'), {
  hideLoader: true,
});
